
import { defineComponent } from 'vue';
import { toKebabCaseId } from '@/core/services/core.utils';

export default defineComponent({
	props: {
		datum: {
			type: Array,
			required: true
		}
	},
	setup() {
		return { toKebabCaseId }
	}
})
